import { baseApi } from './baseApi';

export const referralApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitReferral: builder.mutation({
      query: (referralData) => ({
        url: `/refer_requests`,
        method: 'POST',
        body: referralData,
      }),
      invalidatesTags: ['Referral'],
    }),
    getReferral: builder.query({
      query: ({ referralId }) => ({
        url: `/refer_requests/${referralId}`,
        method: 'GET',
      }),
      providesTags: ['Referral'],
    }),
    updateReferral: builder.mutation({
      query: ({ referralId, referralData }) => ({
        url: `/refer_requests/${referralId}`,
        method: 'PUT',
        body: referralData,
      }),
      invalidatesTags: ['Referral'],
    }),
    updateReferralAttentionStatus: builder.mutation({
      query: ({ referralId, attention_required }) => ({
        url: `/refer_requests/${referralId}/update_attention_status`,
        method: 'PATCH',
        body: { attention_required },
      }),
      invalidatesTags: ['Referral'],
    }),
    getSkills: builder.query({
      query: ({ organizationId } = {}) => ({
        url: `${organizationId ? `/skills?organization_id=${organizationId}` : '/skills'}`,
        method: 'GET',
      }),
    }),
    getSelectedContact: builder.query({
      query: ({ contactId }) => ({
        url: `/member/user_contacts/${contactId}`,
        method: 'GET',
      }),
      providesTags: ['Referral'],
    }),
    getReferData: builder.query({
      query: (token) => ({
        url: `/refer_requests/refer_data`,
        method: 'GET',
        params: { token },
      }),
    }),
  }),
});

export const {
  useSubmitReferralMutation,
  useGetSkillsQuery,
  useUpdateReferralMutation,
  useUpdateReferralAttentionStatusMutation,
  useGetReferralQuery,
  useGetSelectedContactQuery,
  useGetReferDataQuery,
} = referralApi;
